import { Alert } from "@material-ui/lab";
import React, { useState } from "react";
import JSONInput from "react-json-editor-ajrm";
import {
  BackButton,
  PrimaryButton,
  TertiaryButton,
  TextField,
} from "../../components/AtomComponents";
import useDataService from "../../hooks/useDataService";
import { eMessageType } from "../../types/IMessageType";
import { fetchData } from "../../_lib/lib";
import { localeEn } from "../ConfigTenant/ConfigTenant";
import { Wait } from "./SchemaSync";
import { checkForSuccesInvocation } from "../../_lib/utils";
import Dialog from "../../components/Dialog/Dialog";
interface IProps {
  syncFor: string;
}

const VerticalSync = ({ syncFor }: IProps) => {
  const [environment, setEnvironment] = React.useState("");
  const [release, setRelease] = React.useState("");
  const [processState, setProcessState] = React.useState<number>(0);
  const [previewState, setPreviewState] = React.useState<any>(null);
  const [confirmationDialog, setConfirmationDialog] = useState<boolean>(false)
  const { openSnackBar } = useDataService();
  const schemaSync = async () => {
    closeConfirmationDialog();
    setProcessState(1);
    const res: any = await fetchData(
      "PATCH",
      `schema-sync${
        syncFor !== "master" ? "-slave" : ""
      }/vertical-sync`,
      {
        body: { environment, release },
      }
    );
    if (!res.error) {
      try {
        checkForSuccesInvocation(res, setPreviewState, setProcessState)
      } catch (e: any) {
        openSnackBar(
          e.message || 'Something went wrong,Unable to check status',
          eMessageType.error
        );
      }
    } else {
      setProcessState(0);
      setPreviewState(null);
      openSnackBar("Vertical Sync Failed", eMessageType.error);
    }
  };

  const closeConfirmationDialog = () => {
    setConfirmationDialog(false);
  }

  const openConfirmationDialog = () => {
    setConfirmationDialog(true);
  }

  return (
    <>
      <div className="cell small-6 medium-6 px-one-line-data margin-bottom-2">
        <BackButton />
        <h3 className="small-12 margin-bottom-1">Sync across Environment</h3>
      </div>
      {processState === 0 && (
        <>
          <TextField
            label="Environment"
            size="small"
            value={environment}
            onChange={(e) => {
              setEnvironment(e.target.value);
            }}
            placeholder="Environment"
            className="margin-right-1"
          />
          <TextField
            label="Release"
            size="small"
            value={release}
            onChange={(e) => {
              setRelease(e.target.value);
            }}
            placeholder="Release"
            className="margin-right-1"
          />
          <PrimaryButton disabled={!environment.length || !release} onClick={openConfirmationDialog}>
            Sync
          </PrimaryButton>
        </>
      )}
      {processState === 1 && <Wait />}
      {processState === 2 && (
        <>
          <div className="margin-bottom-3">
            <JSONInput
              id={`${syncFor}-vertical-jsonEditor`}
              theme="light_mitsuketa_tribute"
              locale={localeEn}
              placeholder={previewState}
              height="550px"
              width="100%"
              viewOnly={true}
              style={{ body: { fontSize: "16px" } }}
            />
          </div>
          <Alert severity="success" className="margin-bottom-3">
            Schema sync completed!
          </Alert>
          <PrimaryButton onClick={() => setProcessState(0)}>
            Restart
          </PrimaryButton>
        </>
      )}
      <Dialog
        isDialogOpen={confirmationDialog}
        closeDialog={closeConfirmationDialog}
        content={<>This is to sync across <b>{environment}</b>. Do you really want to execute it?</>}
        actions={
          <>
            <TertiaryButton onClick={closeConfirmationDialog}>
              Cancel
            </TertiaryButton>
            <PrimaryButton onClick={schemaSync}>Sync</PrimaryButton>
          </>
        }
      />
    </>
  );
};

export default VerticalSync;
